export const SHOW = 'ALERT:SHOW'
export const HIDE = 'ALERT:HIDE'
